<!-- 详情弹窗 -->
<template>
  <a-modal
    title="详情"
    :width="640"
    :footer="null"
    :visible="visible"
    @update:visible="updateVisible"
  >
    <a-form
      class="ud-form-detail"
      :label-col="{ sm: { span: 6 }, xs: { span: 8 } }"
      :wrapper-col="{ sm: { span: 18 }, xs: { span: 16 } }"
    >
      <a-row :gutter="16">
        <a-col :sm="24" :xs="24">
          <!-- 租赁点名称 -->
          <a-form-item label="团队名称:">
            <div class="ud-text-secondary">
              {{ data.corpName }}
            </div>
          </a-form-item>
          <!-- 租赁点类型 -->
          <a-form-item label="团队类型:">
            <div class="ud-text-secondary">
              {{ data.corpType }}
            </div>
          </a-form-item>
          <a-form-item label="联系方式:">
            <div class="ud-text-secondary">
              {{ data.phone }}
            </div>
          </a-form-item>
          <a-form-item label="微信号:">
            <div class="ud-text-secondary">
              {{ data.weixinId }}
            </div>
          </a-form-item>
          <!-- 管理人 -->
          <a-form-item label="团队简介:">
            <div class="ud-text-secondary">
              {{ data.introduction }}
            </div>
          </a-form-item>
          <a-form-item label="团队背景:">
            <div class="ud-text-secondary">
              <img class="photo" :src="data.corpBgpic" width="100" />
            </div>
          </a-form-item>
          <a-form-item label="团队照片:">
            <div class="ud-text-secondary">
              <img class="photo" :src="data.corpPic" width="100" />
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'OperRecordDetail',
  emits: ['update:visible'],
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 数据
    data: Object
  },
  data() {
    return {}
  },
  watch: {
    data() {}
  },
  methods: {
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value)
    }
  }
}
</script>

<style scoped>
.photo {
  width: 200px;
  height: 100px;
  margin: 20px 0;
}
</style>
